export const subscriptionPlans = {
  homebuyer_basic: "Homebuyer Basic",
  homebuyer_premium: "Homebuyer Premium",
  agent_zip_code: "Agent Premium",
  loan_officer_state: "Loan officer Premium",
  agent_basic: "Agent Basic",
  agent_basic_10: "Agent Basic",
  agent_basic_free: "Agent Basic",
  loan_officer_basic: "Loan Officer Basic",
  loan_officer_basic_10: "Loan Officer Basic",
  loan_officer_basic_free: "Loan Officer Basic",
};
